import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import FooterOne from '../common/footer/FooterOne';
import FooterTwo from '../common/footer/FooterTwo';

import HeaderFive from '../common/header/HeaderFive';
import SplashHeader from '../common/header/SplashHeader';

import SEO from '../common/SEO';
import BannerFour from '../component/banner/BannerFour';
import BlogOne from '../component/blog/BlogOne';
import BrandOne from '../component/brand/BrandOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import ProjectFour from '../component/project/ProjectFour';

import ServicePropOne from '../component/service/ServicePropOne';
import SectionTitle from '../elements/section-title/SectionTitle';
import AboutThree from '../component/about/AboutThree';
import ProyectSix from '../component/project/ProyectSix';

import TestimonialOne from '../component/testimonial/TestimonialOne';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';

const HomeStartup = () => {

    const inicioRef = useRef(null);
    const nosotrosRef = useRef(null);
    const serviciosRef = useRef(null);
    const planesRef = useRef(null);
    const [planActivo, setPlanActivo] = useState(1);

    const location = useLocation();

    // const scrollToServicios = () => {
    //     if (serviciosRef.current) {
    //         serviciosRef.current.scrollIntoView({ behavior: "smooth" });
    //     }
    // };
    // const scrollToPlanes = (filterId) => {
    //     setPlanActivo(filterId);

    //     if (planesRef.current) {
    //         planesRef.current.scrollIntoView({ behavior: "smooth" });
    //     }
    // };

    useEffect(() => {

        if (!location.hash) {
            return;
        }

        const sectionId = location.hash.replace('#', '');

        // Si venimos de otra página hacia Planes,
        // restauramos el tab solicitado.
        if (
            sectionId === 'planes' &&
            location.state &&
            location.state.tabId
        ) {
            setPlanActivo(location.state.tabId);
        }

        setTimeout(() => {

            const element = document.getElementById(sectionId);

            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }

        }, 100);

    }, [location]);

    const scrollToSection = (section, extra) => {
        
        if (section === 'inicio') {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }

        if (section === 'planes') {
            if (extra && extra.tabId) {
                setPlanActivo(extra.tabId);
            }

            if (planesRef.current) {
                planesRef.current.scrollIntoView({ behavior: "smooth" });
            }
        }

        if (section === 'servicios') {
            if (serviciosRef.current) {
                serviciosRef.current.scrollIntoView({ behavior: "smooth" });
            }
        }
        
        if (section === 'nosotros') {
            if (nosotrosRef.current) {
                nosotrosRef.current.scrollIntoView({ behavior: "smooth" });
            }
        }

        // if (section === 'about') {
        //     if (aboutRef.current) {
        //         aboutRef.current.scrollIntoView({ behavior: "smooth" });
        //     }
        // }
    };


    return (
        <>
        <SEO title="Home Startup"/>
        <ColorSwitcher />
        <main className="main-wrapper">
        <HeaderFive onNavigate={scrollToSection}/>
        {/* <HeaderTwo /> */}
        <div ref={inicioRef} id='inicio'>
            <BannerFour />
        </div>
        <div className="section section-padding-2 bg-color-dark" ref={serviciosRef} id="servicios">
                <div className="container">
                    <SectionTitle 
                        subtitle="Que podemos hacer para ti"
                        title="Servicios que pueden ayudarte en..."
                        description="Soluciones diseñadas para mejorar tus procesos, optimizar recursos y llevar el control total de tu empresa."
                        textAlignment="heading-light-left"
                        textColor=""
                    />
                    <div className='row'>
                        <ServicePropOne onNavigate={scrollToSection} colSize="col-xl-4 col-md-6" serviceStyle="" itemShow="4" />
                    </div>
                </div>
                <ul className="list-unstyled shape-group-10">
                    <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/line-9.png"} alt="Circle" /></li>
                    <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/bubble-42.png"} alt="Circle" /></li>
                    <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/bubble-43.png"} alt="Circle" /></li>
                </ul>
            </div>
        {/* <ProjectFour /> */}
        {/* <TestimonialOne /> */}
        <div ref={planesRef} id='planes'>
            <ProyectSix activeFilterId={planActivo} />
        </div>
        {/* <BrandOne /> */}
        <div ref={nosotrosRef} id='nosotros'>
            <AboutThree />
        </div>
        <BlogOne />
        <CtaLayoutOne />
        <FooterTwo />
        </main>
        </>
    )
}

export default HomeStartup;

